// extracted by mini-css-extract-plugin
module.exports = {"understanding-check":"understanding-check__24TGD","text":"text__3MpGZ","section-title":"section-title__27v3V","button-wrapper":"button-wrapper__1Slte","button":"button__2itDe"};